import { Component, ElementRef, Input, ViewChild, inject } from "@angular/core";
import { IgxGridComponent } from '@infragistics/igniteui-angular/grids/grid';
import { GridFilterService } from "../../../services";
import { PopoverComponent } from "@tylertech/forge";

@Component({
    selector: "grid-search",
    templateUrl: "./gridSearch.tmpl.html",
    standalone: false
})
export class GridSearchComponent
{
    private $gridFilterService = inject(GridFilterService);

    @Input() grid: IgxGridComponent;
    @Input() columns: any[];

    @ViewChild("searchFilter") searchFilter: ElementRef;
    @ViewChild("popover") popover: PopoverComponent;

    get hasSearchFilter(): boolean
    {
        return !!this.$gridFilterService.searchText;
    }

    get searchText(): string
    {
        return this.$gridFilterService.searchText;
    }

    set searchText(value: string)
    {
        this.$gridFilterService.searchText = value;
    }

    toggleSearchPopover($event: any): void
    {
        if ($event.detail?.newState === "open")
            this.searchFilter.nativeElement.focus();
    }

    cancel(): void
    {
        this.popover.open = false;
        this.searchText = "";
    }

    clearFilter(): void
    {
        this.searchText = "";
        this.$gridFilterService.clearFilter(this.grid);
    }

    searchKeyDown(event: KeyboardEvent): void
    {
        if (event.key !== "Enter")
            return;
        event.preventDefault();
        event.stopPropagation();
        this.applySearch();
    }

    applySearch(): void
    {
        this.$gridFilterService.searchFilter(this.$gridFilterService.searchText, this.columns, this.grid);
        this.popover.open = false;
    }
}
